import { Wifi, WifiOff, Loader2 } from 'lucide-react'
import { useIntl } from 'react-intl'
import { cn } from '../utils/cn'
import type { ConnectionState } from '../services/websocket'

/**
 * Live-status pill — WebSocket connection state, always visible in the shell.
 * Text label + icon (never colour alone).
 */
export function LiveStatusPill({ state, expanded, className }: { state: ConnectionState; expanded: boolean; className?: string }) {
  const intl = useIntl()
  const meta = {
    connected: { icon: <Wifi className="w-4 h-4" aria-hidden />, label: intl.formatMessage({ id: 'shell.live.connected', defaultMessage: 'Live' }), cls: 'text-emerald-300' },
    connecting: { icon: <Loader2 className="w-4 h-4 animate-spin" aria-hidden />, label: intl.formatMessage({ id: 'shell.live.connecting', defaultMessage: 'Reconnecting…' }), cls: 'text-amber-300' },
    disconnected: { icon: <WifiOff className="w-4 h-4" aria-hidden />, label: intl.formatMessage({ id: 'shell.live.offline', defaultMessage: 'Offline' }), cls: 'text-red-300' },
  }[state]
  return (
    <div
      role="status"
      aria-live="polite"
      title={meta.label}
      className={cn('flex items-center gap-3 px-3 py-2 rounded-lg text-xs font-medium', meta.cls, className)}
    >
      <span className="shrink-0 w-5 flex justify-center">{meta.icon}</span>
      {expanded ? <span className="truncate">{meta.label}</span> : <span className="sr-only">{meta.label}</span>}
    </div>
  )
}

export default LiveStatusPill
